// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import '../static/js/ydui.flexible.js'
import YDUI from 'vue-ydui';
import 'vue-ydui/dist/ydui.rem.css';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import store from './store';
Vue.use(preview);

Vue.config.productionTip = false
Vue.use(YDUI);
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store: store,
  components: {App},
  template: '<App/>'
})

// 腾讯广告全局申明只需运行一次
window.TencentGDT = window.TencentGDT || [];


// WEBPACK FOOTER //
// ./src/main.js